<script setup lang="ts" generic="T">
import { useTypedIntl } from "@/locales/typed-intl";

import ListLoader from "@/components/ui/loader/list-loader.vue";

interface IProps {
  items?: T[];
}

const props = defineProps<IProps>();

const { t, k } = useTypedIntl();
</script>

<template>
  <div class="px-4 border rounded-md w-full simple-list">
    <template v-if="items">
      <template v-if="items.length">
        <div
          v-for="(data, index) in props.items"
          :key="index"
          class="simple-list-item py-4"
        >
          <slot
            :item="{ data, index }"
            name="item"
          >
            <span class="py-4">
              {{ data }}
            </span>
          </slot>
        </div>
      </template>
      <div
        v-else
        class="m-16 flex justify-center"
      >
        {{ t(k.global.misc.noResult) }}
      </div>
    </template>
    <ListLoader
      v-else
      class="py-4"
    />
  </div>
</template>

<style lang="scss">
.simple-list {
  &-item {
    &:not(:last-child) {
      @apply border-b;
    }
  }
}
</style>
